<div class="body-top d-flex justify-content-between mb-15">
  <a [attr.href]="supplierService.getImportExampleFileUrl()" class="left-text text-neutral-n9"><span class="icon-export me-2"></span>Download example file</a>
  <span class="right-text text-neutral-n9">Max Rows: {{ MAX_ROWS }}</span>
</div>

<div>
  <div class="form-group">
    <input-file (change)="onChangeImportFile($event)" [accept]="accept" [acceptExtensions]="acceptExtensions" [maxSize]="1048576" [maxFiles]="1"></input-file>
  </div>
  <div class="error-section">
    <div class="error-note" *ngIf="rowsCount > MAX_ROWS">
      <span class="d-block">The file contains too many rows ({{ rowsCount }})</span>
    </div>
    <table class="error-table" *ngIf="itemCounts.length">
      <thead>
        <tr>
          <th>Supplier</th>
          <th>Count</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let itemCount of itemCounts">
          <td>{{ itemCount.item}}</td>
          <td>{{ itemCount.count }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button (click)="import.emit([])" class="btn btn-outline-dark">Cancel</button>
      <button (click)="onSubmitImport()" [disabled]="!(rowsCount)" class="btn btn-primary ms-15">Import <span *ngIf="rowsCount">({{
          rowsCount }})</span></button>
    </div>
  </div>
</div>
